import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import React from "react";

type WeatherLocationProps = React.PropsWithChildren<{ location: string }>;

export const WeatherLocation: React.FC<WeatherLocationProps> = ({
    location,
}) => {
    const { productPage } = useI18n("productPage");
    return (
        <div style={{ alignSelf: "start" }}>
            <Text.Heading order="5" tag="h3">
                {location}
            </Text.Heading>
            <Text.Body>{productPage.weather.averages.l()}</Text.Body>
        </div>
    );
};
